/* eslint-disable */
var icon = require("vue-svgicon");
icon.register({
  "mass-export-squares": {
    width: 24,
    height: 24,
    viewBox: "-2 -2 25 25",
    data: '<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1.5H7.5V7.5H1.5V1.5ZM0 9V0H9V9H0ZM13.5 1.5H19.5V7.5H13.5V1.5ZM12 9V0H21V9H12ZM7.5 13.5H1.5V19.5H7.5V13.5ZM0 12V21H9V12H0ZM13.5 13.5H19.5V19.5H13.5V13.5ZM12 21V12H21V21H12Z" fill="black"/> </svg>'
  }
});
